export enum Role {
  FotiouAdmin = 1,
  FotiouCustomerService = 2,
  CustomerAdmin = 3,
  CustomerMember = 4
}
